import { Component } from '@angular/core';

@Component({
	selector: 'vcm-signals',
	template: require('./signals.component.html')
})

export class SignalsComponent {
}